import React from 'react';
import { Area, AreaChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip as ChartTooltip, XAxis, YAxis } from 'recharts';
import { SectionCard } from '../common/SectionCard';
import { intakeSummary, intakeTrend } from '../../data/dashboard';
export function IntakeTrendChart() {
  return <SectionCard title="Application intake — trailing 12 months" description="New applications received per month, by track" actions={<span className="rounded-sm border border-uae-leaf/30 bg-uae-leaf/10 px-1.5 py-0.5 font-mono text-[11px] text-uae-leaf" data-id="element-598" data-mp="1nk5v404qf0v2">
          +{intakeSummary.yearOnYearChange}% YoY
        </span>} data-id="element-597" data-mp="pzjd9toi3n60">
      <dl className="mb-3 grid grid-cols-3 gap-3 border-b border-border pb-3" data-id="element-599" data-mp="18p9h16a8rja2">
        <div data-id="element-600" data-mp="18rc53kru32c5">
          <dt className="text-[11px] uppercase tracking-[0.08em] text-muted-foreground" data-id="element-601" data-mp="18rly7h86dpm2">
            Received
          </dt>
          <dd className="font-mono text-lg font-semibold" data-id="element-602" data-mp="3teysrafneoyj">{intakeSummary.trailingTwelveMonths}</dd>
        </div>
        <div data-id="element-603" data-mp="l9zstku9mbux">
          <dt className="text-[11px] uppercase tracking-[0.08em] text-muted-foreground" data-id="element-604" data-mp="lbkpbg0544vf">
            Approval rate
          </dt>
          <dd className="font-mono text-lg font-semibold" data-id="element-605" data-mp="q79rzs7gi1vy">{intakeSummary.approvalRate}%</dd>
        </div>
        <div data-id="element-606" data-mp="beg1lbqnc1ci">
          <dt className="text-[11px] uppercase tracking-[0.08em] text-muted-foreground" data-id="element-607" data-mp="gb6fptiw4mva">
            Mean decision
          </dt>
          <dd className="font-mono text-lg font-semibold" data-id="element-608" data-mp="2ji925reuqlp">{intakeSummary.meanDecisionDays}d</dd>
        </div>
      </dl>
      <div className="h-56 w-full" data-id="element-609" data-mp="7b9vq57g4c6k">
        <ResponsiveContainer width="100%" height="100%" data-id="element-610" data-mp="7cbd0rf21uwq">
          <AreaChart data={intakeTrend} margin={{
          top: 4,
          right: 8,
          left: -20,
          bottom: 0
        }} data-id="element-611" data-mp="3osaz85yuf22e">
            <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" vertical={false} data-id="element-612" data-mp="3tquoogcnavzi" />
            <XAxis dataKey="month" tick={{
            fontSize: 10,
            fill: 'var(--muted-foreground)'
          }} tickLine={false} axisLine={{
            stroke: 'var(--border)'
          }} data-id="element-613" data-mp="3frcu1kco4oi8" />
            <YAxis allowDecimals={false} tick={{
            fontSize: 11,
            fill: 'var(--muted-foreground)'
          }} tickLine={false} axisLine={false} data-id="element-614" data-mp="1qar27kcm6tzw" />
            <ChartTooltip contentStyle={{
            fontSize: 12,
            borderRadius: 4,
            border: '1px solid var(--border)'
          }} data-id="element-615" data-mp="1gjwe0aft5kbt" />
            <Legend wrapperStyle={{
            fontSize: 11
          }} data-id="element-616" data-mp="2980m12luq9ho" />
            <Area type="monotone" dataKey="International" stackId="1" stroke="var(--chart-6)" fill="var(--chart-6)" fillOpacity={0.45} data-id="element-617" data-mp="296pgoycrctog" />
            <Area type="monotone" dataKey="Major" stackId="1" stroke="var(--chart-3)" fill="var(--chart-3)" fillOpacity={0.6} data-id="element-618" data-mp="1zbp8686m5bl4" />
            <Area type="monotone" dataKey="Mega" stackId="1" stroke="var(--chart-1)" fill="var(--chart-1)" fillOpacity={0.75} data-id="element-619" data-mp="jtca12h6atk6" />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </SectionCard>;
}